<template>
  <highcharts :options="chartOptions"></highcharts>
</template>

<script>
import { Chart } from 'highcharts-vue';

export default {
  components: {
    highcharts: Chart,
  },
  props: ['projectsURoof'],
  computed: {
    projects: {
      get: function() {
        return this.$store.state.projects;
      },
      set: function(Project) {
        this.$store.dispatch('setProjects', Project);
      },
    },
    schema: {
      get: function() {
        return this.$store.state.schema;
      },
      set: function(newSchema) {
        this.$store.dispatch('setSchema', newSchema);
      },
    },

    thermalRoofSeries() {
      let thermalRoofData = [];
      thermalRoofData.push({
        name: this.schema.inputs.step1.project_name,
        data: [this.schema.inputs.step5A.roof_u_value || 0],
      });
      console.log('Thermal roof data', thermalRoofData);
      return thermalRoofData;
    },
    chartOptions() {
      return {
        chart: {
          type: 'column',
          width: 300,
          height: 300,
        },
        credits: {
          enabled: false,
        },
        title: {
          text: 'Thermal Transmittane of roof assembly',
        },
        xAxis: {
          // type: 'category',
          // categories: this.projectNames,
          categories: [''],
          title: {
            text: 'Project',
          },
        },
        yAxis: {
          title: {
            text: 'U-value (W/m2.k)',
          },
        },
        legend: {
          enabled: true,
        },
        plotOptions: {
          column: {
            minPointLength: 4,
          },
        },

        series: this.thermalRoofSeries,
      };

      // };
    },
  },
  data() {
    return {
      //
    };
  },
};
</script>

<style></style>
